import React, { FC, useContext, useEffect, useState } from 'react';
import { Text } from '@grupoboticario/flora-react';
import content from 'src/common/content';
import { CatalogContext } from 'src/contexts/Catalog';
import {
  MobileDrawer,
  TrackingAction,
} from 'src/components/molecules/MobileDrawer';
import ProductDetails from 'src/components/organisms/ProductDetails';
import { IProduct } from 'src/common/types/CatalogType';
import sendGoogleAnalytics from 'src/services/googleAnalytics/sendGoogleAnalytics';
import { MemoizedProductsList } from 'src/components/organisms/ProductsList';
import { sendProductClickEvent } from 'src/services/googleAnalytics/enhancedEcommerce';
import sendClickEvent from 'src/services/googleAnalytics/helpers/sendClickEvent';

const getOpenedDrawerTitle = (hasSelectedProduct: boolean) => {
  if (hasSelectedProduct) {
    return content.productsList.productDetailsTitle;
  }

  return content.productsList.openedSectionTitle;
};

const dispatchEventAnalytics = (action: TrackingAction) => {
  sendGoogleAnalytics.event({
    eventCategory: `${process.env.BRAND_IDENTIFIER}:catalogo-virtual`,
    eventAction: 'clique',
    eventLabel: `drawer-product-list:${action}`,
  });
};

export const ProductsDrawer: FC = () => {
  const [{ page }] = useContext(CatalogContext);
  const [selectedProduct, setSelectedProduct] = useState<IProduct>();

  useEffect(() => {
    setSelectedProduct(undefined);
  }, [page]);

  const selectProductHandler = (
    product: IProduct,
    productPosition: number,
  ): void => {
    setSelectedProduct(product);
    sendProductClickEvent(product, [page], productPosition);
  };

  const hasSelectedProduct = !!selectedProduct;
  const shouldShowResellerButton = !!content.products.findReseller;

  const handleBackButton = () => {
    setSelectedProduct(undefined);
    sendClickEvent.goBackProductDetail();
  };

  return (
    <MobileDrawer
      openedTitle={getOpenedDrawerTitle(hasSelectedProduct)}
      closedTitle={content.productsList.closedSectionTitle}
      hasContent={true}
      hasInnerLevel={hasSelectedProduct}
      handleBackFromInnerLevel={handleBackButton}
      eventAnalytics={dispatchEventAnalytics}
    >
      {!!selectedProduct && (
        <ProductDetails
          product={selectedProduct}
          shouldShowResellerButton={shouldShowResellerButton}
          showPrice={content.products.showPrice}
        />
      )}

      <>
        {!hasSelectedProduct && (
          <Text size="bodyLargeStandard" css={{ paddingLeft: '$4' }}>
            {`Página ${page}`}
          </Text>
        )}
        <MemoizedProductsList
          isVisible={!hasSelectedProduct}
          onSelectProduct={selectProductHandler}
        />
      </>
    </MobileDrawer>
  );
};
